import { http } from './base/http';
import type { TemplateTag } from './types/tag';

export const TemplateTagAPIs = {
    async deleteTemplateTag(tagId: number): Promise<Record<string, unknown>> {
        return await http.delete(`/template_tags/${tagId}`);
    },
    async createTemplateTag(templateId: number, tagId: number): Promise<TemplateTag> {
        return await http.post<TemplateTag>('/template_tags', { template: templateId, tag: tagId });
    },
};
